export default {
  crud: {
    new: 'Registro creado correctamente',
    update: 'Registro actualizado correctamente',
    delete: 'Registro eliminado correctamente',
    fail: 'Ha ocurrido un error al momento de intentar grabar los datos',
  },
  dataFetch: {
    success: 'Ha tenido exito en esta operación',
    fail: 'Ha ocurrido un error al momento de cargar los datos',
    sendCode: 'Hemos enviado el codigo con exito a su correo.',
    signatureInvalid: 'El documento no ha sido firmado aún',
  },
  errors: {
    submitting: 'Ocurrió un error al enviar la información',
    invalidFormat: 'Solicitud inválida',
    codeNoValid: 'Lo sentimos, código no valido.',
    login: 'La contraseña o el usuario son invalidos, intente de nuevo por favor.',
  },
};
